import { render, staticRenderFns } from "./AsideUpdates.vue?vue&type=template&id=3bb98968&"
import script from "./AsideUpdates.vue?vue&type=script&lang=js&"
export * from "./AsideUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports